export default "__VITE_ASSET__da56b2de__"